import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { getAccountType } from "../../../http/api/MasterAPI";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const AccountTypeSelect = ({ name, ...props }) => {
  const [listAccountType, setListAccountType] = useState([]);
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  useEffect(() => {
    GetAccountType();
  }, []);

  async function GetAccountType() {
    try {
      const response = await getAccountType();
      const varList = response.masterVarInfo;
      const result = varList.map((element) => ({
        accountTypeCd: element.varCd,
        accountTypeName: element.varValue1,
      }));
      setListAccountType(result);
    } catch (error) {
      console.error("Failed to fetch sales record types:", error);
    }
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
    props.moveNext();
  };

  return (
    <FormControl {...props} error={meta.touched && Boolean(meta.error)}>
      <InputLabel id={`${name}-label`} shrink>
        {props.label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        {...field}
        onChange={handleChange}
        label={props.label}
        value={field.value === null ? -1 : field.value}
        inputRef={props.inputRef}
      >
        <MenuItem value={-1}>未選択</MenuItem>
        {listAccountType.map((type) => (
          <MenuItem key={type.accountTypeCd} value={type.accountTypeCd}>
            {type.accountTypeName}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default AccountTypeSelect;
